var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0131253 3.13333C0.0131253 1.685 1.18125 0.5 2.625 0.5H12.0356C12.7313 0.5 13.4006 0.7765 13.8863 1.27683L20.2256 7.63633C20.7244 8.1235 21 8.795 21 9.49283V24.2C21 25.6483 19.8188 26.8333 18.375 26.8333H2.61187C1.16812 26.8333 0 25.6483 0 24.2L0.0131253 3.13333Z",
    fill: "#BDC0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 6.62056V1.16602L20.3334 7.83268H14.8789C14.2122 7.83268 13.6667 7.28723 13.6667 6.62056Z",
    fill: "#B0B3F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15.5,
    width: 8.66667,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 4.33333,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.166,
    width: 8.66667,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11.166,
    width: 4.33333,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20.834,
    width: 8.66667,
    height: 1.33333,
    rx: 0.666667,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 22,
    r: 6.5,
    fill: "#F05B94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3649 25.4993H18.6307C18.9423 25.4993 19.1972 25.2373 19.1972 24.917V22.0052H20.0979C20.602 22.0052 20.8569 21.3763 20.5 21.0094L17.9 18.3363C17.7941 18.2273 17.6505 18.166 17.5006 18.166C17.3508 18.166 17.2071 18.2273 17.1013 18.3363L14.5012 21.0094C14.1443 21.3763 14.3936 22.0052 14.8977 22.0052H15.7984V24.917C15.7984 25.2373 16.0533 25.4993 16.3649 25.4993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5308bd2f.svg";
export { ForwardRef as ReactComponent };